import { render, staticRenderFns } from "./DeliveriesTable.vue?vue&type=template&id=618004ef&scoped=true"
import script from "./DeliveriesTable.vue?vue&type=script&lang=js"
export * from "./DeliveriesTable.vue?vue&type=script&lang=js"
import style0 from "./DeliveriesTable.vue?vue&type=style&index=0&id=618004ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618004ef",
  null
  
)

export default component.exports